import { render, staticRenderFns } from "./LinkedInIcon.vue?vue&type=template&id=5e6681d3&scoped=true&"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js&"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInIcon.vue?vue&type=style&index=0&id=5e6681d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6681d3",
  null
  
)

export default component.exports